import React, { useState } from 'react';
import FilterAspirants from './Filters';
import ProfiledAspirants from './ProfiledAspirants';
import { SelectDD, ExternalDD } from '../../common/dropdowns';
import { relocateType } from '../../appConstants';
import { visaType } from '../../appConstants';

function ShortlistAspirants(props) {
    
    return (
        <div className="page-wrapper">          
            <div className="row"  >
                <div className="wd-pct-25 pd-l-5"  >
                    <FilterAspirants/>
                </div>
                <div className="wd-pct-2"  >
                </div>
                <div className="wd-pct-73 pd-r-5"  >
                <ProfiledAspirants/>
                </div>
            </div>      
        </div>
    
    );
  }

export default ShortlistAspirants